module.exports = __webpack_public_path__ + "media/small/real_estate_condos_sale-small-b1dca3c2.jpeg";